import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var FolderOpenIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M6.172 3a3 3 0 012.12.879l.83.828A1 1 0 009.827 5H18a3 3 0 013 3l.001.1a3.001 3.001 0 012.151 3.575l-1.615 7A3 3 0 0118.613 21H4.062a3 3 0 01-2.971-2.583A1 1 0 011 18V6a3 3 0 013-3zm14.057 7H6.216a1 1 0 00-.956.706l-2.154 7A1 1 0 004.062 19h14.551a1 1 0 00.975-.775l1.615-7A1 1 0 0020.23 10zM6.172 5H4a1 1 0 00-1 1v5.248l.348-1.13A3 3 0 016.216 8H19a1 1 0 00-1-1H9.828a3 3 0 01-2.12-.879l-.83-.828A1 1 0 006.173 5z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
FolderOpenIcon.isCarinaIcon = true;
export default FolderOpenIcon;
